import { numericFormatter } from "react-number-format";
import { columns } from "../../../dtos/columns";
import Conversiones from "../../../utils/conversiones";
import { Dividendos } from "../models/dividendos";


interface IProps {
    controlTabla: any;
}

export function useColumns({ controlTabla }: IProps) {

    const COLUMNS: columns<Dividendos>[] = [
        {
            name: 'Nro Dividendo',
            selector: (row) =>
                row.numeroDividendo,
            sortable: true,
            sortField: 'numeroDividendo',
            wrap: true,
            export: true
        },
        {
            name: 'Fecha vencimiento',
            selector: (row) => row.fechaVencimiento ? Conversiones.fechaCortaFormat(row.fechaVencimiento.toString()) : '',
            sortable: true,
            sortField: 'fechaVencimiento',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Amortización',
            selector: (row) =>
                row.amortizacion != null
                    ? `UF ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 4 }).format(row.amortizacion)}`
                    : 0,
            sortable: true,
            sortField: 'amortizacion',
            wrap: true,
            export: true
        },
        {
            name: 'Interés',
            selector: (row) =>
                row.interes != null
                    ? `UF ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 4 }).format(row.interes)}`
                    : 0,
            sortable: true,
            sortField: 'interes',
            wrap: true,
            export: true,
        },
        {
            name: 'Dividendo',
            selector: (row) =>
                row.dividendo != null
                    ? `UF ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 4 }).format(row.dividendo)}`
                    : 0,
            sortable: true,
            sortField: 'dividendo',
            wrap: true,
            export: true
        },
        {
            name: 'Total seguros',
            selector: (row) => {
                const value = row.totalSeguros;
                return typeof value === 'number' && !isNaN(value)
                    ? `UF ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 4 }).format(value)}`
                    : 'UF 0,0000';
            },
            sortable: true,
            sortField: 'totalSeguros',
            wrap: true,
            export: true,
        },
        {
            name: 'Monto cuota',
            selector: (row) => {
                const value = row.montoCuota;
                return typeof value === 'number' && !isNaN(value)
                    ? `UF ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 4 }).format(value)}`
                    : 'UF 0,0000';
            },
            sortable: true,
            sortField: 'montoCuota',
            wrap: true,
            export: true,
        },
        {
            name: 'Estado',
            selector: (row) =>
                row.estado,
            sortable: true,
            sortField: 'estado',
            wrap: true,
            export: true,
        },
        {
            name: 'Fecha recaudación',
            selector: (row) => row.fechaRecaudacion ? Conversiones.fechaCortaFormat(row.fechaRecaudacion.toString()) : '',
            sortable: true,
            sortField: 'fechaRecaudacion',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Estado',
            selector: (row) =>
                row.estado,
            sortable: true,
            sortField: 'estado',
            wrap: true,
            export: true,
        },
        {
            name: 'Total recaudado',
            selector: (row) => {
                const value = row.totalRecaudado;
                return typeof value === 'number' && !isNaN(value)
                    ? `$ ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2 }).format(value)}`
                    : '$ 0,00';
            },
            sortable: true,
            sortField: 'totalRecaudado',
            wrap: true,
            export: true,
        }
    ]


    return { COLUMNS };
}